import { MainLayout } from "components/layouts/MainLayout";
import { AppRouteType } from "navigation/registryRoutes";
import slugs from "navigation/slugs";

import React from "react";
const Profile = React.lazy(() => import("../page/Profile"));

const routes: AppRouteType[] = [
  {
    path: slugs.profile,
    component: Profile,
    container: MainLayout,
    isAuthNeeded: true,
  },
];

export default routes;
